// src/config.js

// Dynamically toggles between Localhost Express port and the Live Vercel Backend domain
const rawBase = process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL || "http://localhost:80";

// Ensure /api is automatically appended to whatever domain the environment provides
export const API_BASE_URL = rawBase.endsWith('/api') ? rawBase : `${rawBase.replace(/\/$/, '')}/api`;
